<template>
  <div id="app">
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <div class="navbar-header">
          <a class="navbar-brand" href="#">Ensofia Dynamic Forms</a>
        </div>
      
      </div>
    </nav>
    <router-view class="view"></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";

import "bootstrap/dist/css/bootstrap.css";

Vue.use(VueRouter);

const Home = require("./views/Home.vue");
const AllForm = require("./views/form/all-form.vue");
const CreateForm = require("./views/form/create-form.vue");


const Survey =  require(/* webpackChunkName: "survey" */ "./views/Survey.vue");
const Creator = 
  require(/* webpackChunkName: "creator" */ "./components/SurveyCreator.vue");
const ExportToPDF = 
  require(/* webpackChunkName: "creator" */ "./views/ExportToPDF.vue");
const Analytics = 
  require(/* webpackChunkName: "creator" */ "./views/Analytics.vue");

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    // { path: "/", component: Home },
    // { path: "/Allform/:client_id", component: AllForm },
    { path: "/CreateForm/:id", name: 'CreateForm',component: CreateForm },

    
    // Just use them normally in the route config
    // { path: "/survey", component: Survey },
    // multiple parameters, `/` should not be encoded. The name is also important
    // https://github.com/vuejs/vue-router/issues/2719
    // { path: '/a/:tags*', name: 'tagged', component: () => new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       template: `<div>
    //         <h2>Lazy with params</h2>
    //         <pre id="tagged-path">{{ $route.path }}</pre>
    //       </div>`
    //     })
    //   }, 200)
    // }) },
    // Bar and Baz belong to the same root route
    // and grouped in the same async chunk.
    { path: "/creator/:id",name:'BuildForm', component: Creator },
    // { path: "/exportpdf", component: ExportToPDF },
    // { path: "/analytics", component: Analytics }
  ]
});

export default {
  name: "app",
  router: router
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// App.vue?589581f1